import { render, staticRenderFns } from "./AssetsAndProducts.vue?vue&type=template&id=cdacdb0c&scoped=true&"
import script from "./AssetsAndProducts.vue?vue&type=script&lang=js&"
export * from "./AssetsAndProducts.vue?vue&type=script&lang=js&"
import style0 from "./AssetsAndProducts.vue?vue&type=style&index=0&id=cdacdb0c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdacdb0c",
  null
  
)

export default component.exports